import EditClientPage from './EditClientPage'
import connect from './connect'

export default connect(EditClientPage)
